import { useEffect, useState } from 'react'

/**
 * Tracks visitor idleness. Returns true after `timeout` ms with no
 * mouse / scroll / key / touch activity; flips back to false on activity.
 */
export function useIdle(timeout = 9000): boolean {
  const [idle, setIdle] = useState(false)

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>

    const reset = () => {
      setIdle(false)
      clearTimeout(timer)
      timer = setTimeout(() => setIdle(true), timeout)
    }

    const events: (keyof WindowEventMap)[] = [
      'mousemove',
      'scroll',
      'keydown',
      'touchstart',
      'click',
    ]
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }))
    reset()

    return () => {
      clearTimeout(timer)
      events.forEach((e) => window.removeEventListener(e, reset))
    }
  }, [timeout])

  return idle
}
